// extracted by mini-css-extract-plugin
module.exports = {"header":"header___1-AGt","spacer":"spacer___2mF7J","logo":"logo___XZ32L","mask":"mask___2yq3Z","overlay":"overlay___1sOnn","content":"content___3nbLx"};